var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BarcodeExternalNative as _BarcodeExternalNative } from './bridges/BarcodeExternalNative';
import { NativeModule as _Module } from './bridges/NativeModule';
import { GearNative as _Gear } from './bridges/GearNative';
import { NativeInterface as _NativeInterface } from './bridges/NativeInterface';
import { ShortcutsNative as _ShortcutsNative } from './bridges/ShortcutsNative';
import { VibratorNative as _VibratorNative } from './bridges/VibratorNative';
import { LoadingScreenNative as _LoadingScreenNative } from './bridges/LoadingScreenNative';
import { SystemInfoNative as _SystemInfoNative } from './bridges/SystemInfoNative';
import { LibsodiumNative as _LibsodiumNative } from './bridges/LibsodiumNative';
import { UsbNative as _UsbNative } from './bridges/UsbNative';
import { DisplaysNative as _DisplaysNative } from './bridges/DisplaysNative';
import { SocialNative as _SocialNative } from './bridges/SocialNative';
import { SocketNative as _SocketNative } from './bridges/SocketNative';
import { PushNotificationNative as _PushNotification } from './bridges/PushNotification';
import { BarcodeCameraReaderNative as _BarcodeCameraReader } from './bridges/BarcodeCameraNative';
import { Helper as _Helper } from './helper';
export var Native;
(function (Native) {
    var BarcodeReader = /** @class */ (function (_super) {
        __extends(BarcodeReader, _super);
        function BarcodeReader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return BarcodeReader;
    }(_BarcodeExternalNative));
    Native.BarcodeReader = BarcodeReader;
    var Module = /** @class */ (function (_super) {
        __extends(Module, _super);
        function Module() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Module;
    }(_Module));
    Native.Module = Module;
    var Gear = /** @class */ (function (_super) {
        __extends(Gear, _super);
        function Gear() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Gear;
    }(_Gear));
    Native.Gear = Gear;
    var NativeInterface = /** @class */ (function (_super) {
        __extends(NativeInterface, _super);
        function NativeInterface() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return NativeInterface;
    }(_NativeInterface));
    Native.NativeInterface = NativeInterface;
    var Shortcuts = /** @class */ (function (_super) {
        __extends(Shortcuts, _super);
        function Shortcuts() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Shortcuts;
    }(_ShortcutsNative));
    Native.Shortcuts = Shortcuts;
    var Vibrator = /** @class */ (function (_super) {
        __extends(Vibrator, _super);
        function Vibrator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Vibrator;
    }(_VibratorNative));
    Native.Vibrator = Vibrator;
    var SystemInfo = /** @class */ (function (_super) {
        __extends(SystemInfo, _super);
        function SystemInfo() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return SystemInfo;
    }(_SystemInfoNative));
    Native.SystemInfo = SystemInfo;
    var Libsodium = /** @class */ (function (_super) {
        __extends(Libsodium, _super);
        function Libsodium() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Libsodium;
    }(_LibsodiumNative));
    Native.Libsodium = Libsodium;
    var LoadingScreen = /** @class */ (function (_super) {
        __extends(LoadingScreen, _super);
        function LoadingScreen() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return LoadingScreen;
    }(_LoadingScreenNative));
    Native.LoadingScreen = LoadingScreen;
    var Usb = /** @class */ (function (_super) {
        __extends(Usb, _super);
        function Usb() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Usb;
    }(_UsbNative));
    Native.Usb = Usb;
    var Displays = /** @class */ (function (_super) {
        __extends(Displays, _super);
        function Displays() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Displays;
    }(_DisplaysNative));
    Native.Displays = Displays;
    var SocialNative = /** @class */ (function (_super) {
        __extends(SocialNative, _super);
        function SocialNative() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return SocialNative;
    }(_SocialNative));
    Native.SocialNative = SocialNative;
    var Socket = /** @class */ (function (_super) {
        __extends(Socket, _super);
        function Socket() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Socket;
    }(_SocketNative));
    Native.Socket = Socket;
    var BarcodeCameraReader = /** @class */ (function (_super) {
        __extends(BarcodeCameraReader, _super);
        function BarcodeCameraReader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return BarcodeCameraReader;
    }(_BarcodeCameraReader));
    Native.BarcodeCameraReader = BarcodeCameraReader;
    var PushNotification = /** @class */ (function (_super) {
        __extends(PushNotification, _super);
        function PushNotification() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return PushNotification;
    }(_PushNotification));
    Native.PushNotification = PushNotification;
    var Helper = /** @class */ (function (_super) {
        __extends(Helper, _super);
        function Helper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Helper;
    }(_Helper));
    Native.Helper = Helper;
    function getContext() {
        return typeof window.native !== 'undefined' ?
            JSON.parse(window.native.getContext()) :
            { screenId: '-1', mainScreenId: 'default' };
    }
    Native.getContext = getContext;
})(Native || (Native = {}));
//# sourceMappingURL=native.js.map